import getImage from "../../ClinicHistory/ClinicEvent/components/PdfReports/GetImage";
import pdfMake from "pdfmake/build/pdfmake.js";
import moment from "moment";
import { calculateAgeParse } from "../../Utils/Patient";
import { formatNumber } from "../../Utils/Money";
import ReportsAPI from '../../Reports/api/reports_api';
import NumberToLetters from '../../../utils/NumberToletters';


const pdfDetailAdvacePayment = async (data) => {
  pdfMake.fonts = {
    OpenSans: {
      normal: "OpenSans-Regular.ttf",
      bold: "OpenSans-Bold.ttf",
      italics: "OpenSans-Italic.ttf",
      bolditalics: "OpenSans-ExtraBoldItalic.ttf",
    },
    Merriweather: {
      normal: "Merriweather-Regular.ttf",
      bold: "Merriweather-Bold.ttf",
      italics: "Merriweather-Italic.ttf",
      bolditalics: "Merriweather-ExtraBoldItalic.ttf",
    },
    Roboto: {
      normal: "Roboto-Regular.ttf",
      bold: "Roboto-Bold.ttf",
      italics: "Roboto-Italic.ttf",
      bolditalics: "Roboto-BoldItalic.ttf",
    },
  };
  console.log("ComingToPDFPayment", data);//

  const city = parseInt(data.profile.direccion.id_ciudad);
  const dept = parseInt(data.profile.direccion.id_dpto);
  const getCity = await ReportsAPI.loadCity(city);
  const getDepts = await ReportsAPI.loadDepartment();
  const deptoProfile = getDepts.find((depto) => depto.id === dept);
  const today = new Date();

  let urlServe =
    process.env.REACT_APP_PUBLIC_URL +
    "usuario/" +
    data.infoAdvance?.id_usuario +
    "/" +
    data.infoAdvance?.firma +
    "/" +
    sessionStorage.getItem("token");
  let urlFirma = "";
  let test = fetch(urlServe).then((response) => {
    if (response.status === 500) {
      return false;
    } else {
      return true;
    }
  });

  let isImg = await test;

  if (isImg) {
    urlFirma = urlServe;
  } else {
    urlFirma = "https://i.postimg.cc/0jznYVsr/prueba.png";
  }

  const header = {
    margin: [40, 10, 0, 0],
    layout: "noBorders",
    table: {
      widths: ["*", "*"],
      body: [
        [
          {
            image: await getImage(data.urlLogo),
            fit: [100, 40],
          },
          {
            text:
              data.profile.direccion.direccion +
              " " +
              data.profile.nombre +
              " \n Teléfonos: " +
              data.profile.telefono1 +
              "-" +
              data.profile.telefono2,
            style: "head",
          },
        ],
      ],
    },
  };

  const documentDefinition = {
    pageSize: "LETTER",
    pageOrientation: "portrait",
    header: header,
    pageMargins: [30, 60, 30, 30],
    /* footer: function (currentPage, pageCount) {
      return {
        table: {
          widths: ["*", "*"],
          body: [
            [
              {
                text: "Página " + currentPage.toString() + " de " + pageCount,
                style: "head",
              },
              {
                text:
                  "Fecha Impresión: " + moment(today).format('DD-MM-YYYY'),
                style: "head",
              },
            ],
          ],
        },
        layout: "noBorders",
        margin: [20, 0, 30, 0],
      };
    }, */
    content: [
      { text: data.profile.nombre, style: "headPayment", alignment: 'center' },
      { text: 'NIT:' + data.profile.nit, style: "textStyle", alignment: 'center', lineHeight: 2 },
      {
        text:
          "RECIBO DE ANTICIPOS No." + data.infoAdvance.id_anticipo,
        style: "headPayment",
        alignment: 'center'
      },
      {
        table: {
          widths: ["auto", "*", 'auto', '*'],
          body: [
            [{ text: 'Nombre del Usuario: ', style: "headPayment", alignment: 'left', border: [false, true, false, false] }, { text: data.infoAdvance.nombre, style: "textStyle", border: [false, true, false, false] }, { text: 'Fecha: ', style: "headPayment", alignment: 'left', border: [false, true, false, false] }, { text: moment(data.infoAdvance.fecha_creacion).format('DD-MM-YYYY'), style: "textStyle", border: [false, true, false, false] }],
            [{ text: 'Documento: ', style: "headPayment", alignment: 'left' }, { text: data.infoAdvance.nit, style: "textStyle" }, { text: 'Teléfono: ', style: "headPayment", alignment: 'left' }, { text: data.infoAdvance.telefono, style: "textStyle" }],
            [{ text: 'EPS: ', style: "headPayment", alignment: 'left' }, { text: data.infoAdvance.nombre, style: "textStyle" }, { text: 'Valor: ', style: "headPayment", alignment: 'left' }, { text: '$' + formatNumber(data.infoAdvance.valor), style: "textStyle", bold: true }],
          ],
        },
        layout: {
          defaultBorder: false,
        },
        margin: [20, 5, 0, 5],
      },
      {
        style: 'tableExample',
        table: {
          widths: ["auto", "*"],
          body: [
            [{ text: 'Concepto:', style: 'textStyle', bold: true, border: [false, true, false, true], lineHeight: 2  }, { text: data.infoAdvance.concepto /* + ' - CONSIGNADO EL ' + moment(data.infoAdvance.fecha_creacion).format('LLLL').toUpperCase() */, style: 'textStyle', border: [false, true, false, true], bold: true }],
            [{ text: 'Son:', style: 'textStyle', bold: true }, {
              text: NumberToLetters(data.infoAdvance.valor.toString(), {
                plural: 'PESOS',
                singular: 'PESO',
              }), style: 'textStyle'
            }],
          ]
        },
        layout: {
          defaultBorder: false,
        },
        margin: [20, 5, 0, 5],
      },
      {
        columns: [
          {
            // auto-sized columns have their widths based on their content                                       
            margin: [40, 20, 25, 0],
            layout: 'noBorders',
            table: {
              widths: [110],
              headerRows: 1,
              body: [
                [{
                  image: await getImage(urlFirma),
                  fit: [60, 60],
                  alignment: "center"
                },],
                [{ text: 'Elaboro ' + data.infoAdvance.nombre_usuario, style: 'signature', }],

              ]
            },
          },
          {
            margin: [0, 50, 0, 0],
            text: 'Usuario y fecha de impresión:\n ' + data.user.nombre + ' - ' + moment(today).format('LLL'), style: 'signature',
          },
        ],
      },
    ],
    styles: {
      headPayment: {
        fontSize: 11,
        bold: true,
      },
      headResumenPayment: {
        fontSize: 10,
        bold: true,
      },
      head: {
        fontSize: 7,
        bold: true,
        alignment: "left",
      },
      tableheader: {
        fontSize: 11,
        bold: true,
      },
      textStyle: {
        fontSize: 10,
      },
      tableTexStyle: {
        fontSize: 8,
        alignment: "left",
      },
      foter: {
        alignment: "center",
        fontSize: 6,
      },
      signature: {
        alignment: "center",
        fontSize: 7,
      },
      medicStyle: {
        margin: [0, 5, 0, 0],
        fontSize: 10,
        alignment: "left",
      },
    },
  };

  const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
  pdfDocGenerator.getDataUrl(function (outDoc) {
    document.getElementById("pdfV").src = outDoc;
  });

  //pdfMake.createPdf(documentDefinition).open();
};
export default pdfDetailAdvacePayment;
